export default "__VITE_ASSET__ZgQ8IVMt__"